import Layout from "components/layout/Layout";
import LandingPage from "components/landing/LandingPage";

const HomeOne = () => {
  return (
    <Layout mainCls="main-content fix bodylytix-main" headerStyle={1} footerStyle={1}>
      <LandingPage />
    </Layout>
  );
};

export default HomeOne;
